












































































































import {
  Vue, Prop, Component, Watch,
} from "vue-property-decorator";
import AusterButton from "./AusterButton.vue";
import AusterInput from "./AusterInput.vue";
import AusterSelect from "./AusterSelect.vue";

import authModel from "@/models/auth.model";
import router from "../router";
import { validateEntity, validateCPF } from '../models/entity-validation';
import userModel from "@/models/user.model";
import { format, parse, parseISO } from "date-fns";

@Component({
  components: {
    AusterButton,
    AusterInput,
    AusterSelect
  },
})
export default class LoginModal extends Vue {
  @Prop() openModal?: boolean;

  showModal = false;
  loadingButton = false;
  disableButton = false;
  checkLogin = false;

  userInfo: any = {
    email: "",
    password: "",
    loginConfirmationCode: "",
  };

  loggedUser: any = {};
  updateUser: any = {
    id: 0,
    defaultPassword: "", //0800 Programa de Apoio ou Chave de acesso
    register: "", //Matricula,
    userType: "", //Tipo de Funcionário
    birthDate: "", //Data de Nascimento
    cpf: "", //CPF
    gender: "", //sexo
    phoneNumber: "" //celular
  }
  //para form
  updateDefaultPassword = ""; //0800 Programa de Apoio ou Chave de acesso
  updateRegister = ""; //Matricula,
  updateUserType: ""; //Tipo de Funcionário
  updateBirthDate: ""; //Data de Nascimento
  updateCpf: ""; //CPF
  updateGender: ""; //sexo
  updatePhoneNumber: ""; //celular
  showFields = false;

  fieldErrors: any = {};
  fieldErrorsUpdate: any = {};

  genderOptions: any[] = [{ name: 'Masculino', value: 'M' }, { name: 'Feminino', value: 'F' }, { name: 'Outro', value: 'OTHER' }];
  userTypeOptions: any[] = [{ name: 'Funcionário', value: 'EMPLOYEE' }, { name: 'Dependente', value: 'DEPENDENT' }];

  translateGender(value: string) { // necessary to due vs-select bug
    switch (value) {
      case "M":
        return "MALE";
      case "F":
        return "FEMALE";
      default:
        return "OTHER";
    }
  }

  async showLogin() {
    console.log('show login');
    if (this.$store.state.auth.isUserLoggedIn()) {
      //this.$router.push("/dash");
      this.verificarUsuarioLogado();
    } else {
      this.showModal = true;
      //this.showFields = true;
    }
  }

  closeModal() {
    this.showModal = false;
    this.checkLogin = false;
    this.userInfo.loginConfirmationCode = "";
    this.loadingButton = false;
    this.disableButton = false;
  }

  closeModalUpdate() {
    this.showFields = false;
  }

  keydown0800(event) {
    //console.log(event);
    if (event && event.keyCode === 32) {
      //console.log('space');
      event.preventDefault();
    }
  }

  isEmpty(field) {
    return field === null || field === undefined || field === "";
  }

  validateFieldsUpdate() {
    const validationDefinition: any = [
      { key: "phoneNumber", validation: { kind: 'phone' } },
      { key: "cpf", validation: { kind: 'cpf' } },
      { key: "birthDate", validation: { kind: 'brDate' } },
      { key: "gender", validation: {} },
      { key: "register", validation: {} },
      { key: "userType", validation: {} },
      { key: "defaultPassword", validation: { required: true } },
    ];

    //this.fieldErrors = validateEntity(this.userInfo, validationDefinition, ["name", "phoneNumber", "cpf", "birthDate", "gender", "email", "password", "passwordConfirmation", "terms"]);
    this.fieldErrorsUpdate = validateEntity(this.updateUser, validationDefinition, ["phoneNumber", "cpf", "birthDate", "gender", "register", "userType", "defaultPassword"]);
  }

  cancelUpdate() {
    this.$store.dispatch('auth/logout');
    this.closeModalUpdate();
    this.closeModal();
  }

  async updateFields() {
    console.log(this.updateUser);
    let erroMsg = "";
    //validar campos 
    if (this.isEmpty(this.updateUser.register) || this.isEmpty(this.updateUser.birthDate) || this.isEmpty(this.updateUser.phoneNumber) || this.isEmpty(this.updateUser.cpf) || this.isEmpty(this.updateUser.userType) || this.isEmpty(this.updateUser.gender)) {
      erroMsg = "Preencha todos os campos";
    }

    // if (erroMsg) {
    //   this.$vs.notification({
    //     title: 'Erro',
    //     text: erroMsg,
    //     // iconPack: 'feather',
    //     // icon: 'icon-alert-circle',
    //     color: 'danger'
    //   });
    // }

    this.validateFieldsUpdate();
    if (Object.values(this.fieldErrorsUpdate).filter(error => !!error).length) {
      this.$vs.notification({
        text: "Verifique os erros indicados",
        color: "#FF6767",
      });
      console.error(this.fieldErrorsUpdate);
      return;
    }


    const loading = this.$vs.loading();
    try {
      const userParam = {
        gender: this.updateUser.gender,
        birthDate: this.updateUser.birthDate,
        phoneNumber: this.updateUser.phoneNumber,
        cpf: this.updateUser.cpf,
        userType: this.updateUser.userType,
        register: this.updateUser.register,
        defaultPassword: this.updateUser.defaultPassword
      };
      //delete userParam['company'];
      if (this.loggedUser.birthDate) {
        delete userParam['birthDate'];
      } else {
        userParam.birthDate = parse(userParam.birthDate, "dd/MM/yyyy", new Date());
      }
      if (this.loggedUser.gender) {
        delete userParam['gender'];
      } else {
        userParam.gender = this.translateGender(userParam.gender);
      }
      if (this.loggedUser.phoneNumber) {
        delete userParam['phoneNumber'];
      }
      if (this.loggedUser.cpf && validateCPF(this.loggedUser.cpf)) {
        delete userParam['cpf'];
      }
      if (this.loggedUser.userType) {
        delete userParam['userType'];
      }
      if (this.loggedUser.register) {
        delete userParam['register'];
      }
      if (this.loggedUser.company) {
        delete userParam['defaultPassword'];
      }
      //userParam.userType: this.translateType(userParam.userType),        
      //delete userParam['register'];
      //delete userParam['userType'];
      console.log(userParam);
      await userModel.updateFields(userParam);
      this.$vs.notification({ text: "Seus dados foram atualizados com sucesso", color: "#2E7179" });
      this.showFields = false;
      this.showModal = false;
      router.push((router.currentRoute.query.to || "/dash") as string);

    } catch (error) {
      console.log(error);
      if (error.message) {
        const msg = error.message.includes("Conflict") ? "C.P.F.  já cadastrado." : error.message;
        this.$vs.notification({ text: msg, color: "#FF6767" });
      } else {
        this.$vs.notification({ text: "CPF ou email já cadastrados.", color: "#FF6767" });
      }
      console.error(error);
    }
    loading.close();



  }

  verificarUsuarioLogado() {
    //verificar os dados do usuario para completar
    this.loggedUser = this.$store.state.auth.getActiveUser();
    console.log('update User', this.loggedUser, 'cpf', validateCPF(this.loggedUser.cpf));
    if (this.loggedUser.role === "ADMINISTRATOR" || this.loggedUser.role === "PSYCHOLOGIST") {
      router.push((router.currentRoute.query.to || "/dash") as string);
      return;
    }
    //!this.loggedUser.defaultPassword 
    //if (!this.loggedUser.register || !this.loggedUser.birthDate || !this.loggedUser.phoneNumber || !this.loggedUser.cpf || !this.loggedUser.userType || !this.loggedUser.gender) {
    if (!this.loggedUser.company || this.isEmpty(this.loggedUser.register) || this.isEmpty(this.loggedUser.birthDate) || this.isEmpty(this.loggedUser.phoneNumber) || this.isEmpty(this.loggedUser.cpf) || !validateCPF(this.loggedUser.cpf) || this.isEmpty(this.loggedUser.userType) || this.isEmpty(this.loggedUser.gender)) {
      this.updateUser = { ...this.loggedUser };
      //inicializar variaveis
      this.updateUser.cpf = validateCPF(this.updateUser.cpf) ? this.updateUser.cpf : null; // para não validar cpf antigo com mascara
      this.loggedUser.cpf = this.updateUser.cpf; //se for invalido vai mostrar na tela
      this.updateUser.birthDate = this.updateUser.birthDate ? this.updateUser.birthDate.split("T")[0].split("-").reverse().join("/") : "";
      this.updateUser.gender = this.updateUser.gender ? this.updateUser.gender : "";
      this.updateUser.userType = this.updateUser.userType ? this.updateUser.userType : "";
      if (this.loggedUser.company) {
        this.updateUser.defaultPassword = this.loggedUser.company.defaultPassword ? this.loggedUser.company.defaultPassword : this.loggedUser.company.id;
      }
      //exibir modal 
      console.log('update User format', this.updateUser);
      this.showFields = true;
    } else {
      router.push((router.currentRoute.query.to || "/dash") as string);
    }
  }

  async login() {
    this.validateFields();
    if (Object.values(this.fieldErrors).filter(error => !!error).length) {
      console.error(this.fieldErrors);
      return;
    }

    this.checkLogin = true;
    if (this.userInfo.loginConfirmationCode !== "") {
      try {
        this.loadingButton = true;
        this.disableButton = true;
        const session = await this.$store.dispatch("auth/login", { email: this.userInfo.email, password: this.userInfo.password, loginConfirmationCode: this.userInfo.loginConfirmationCode });
        if (session) {
          console.log('logado');

          this.verificarUsuarioLogado()

        }
      } catch (error) {
        if (error.message === "Account is pending approval") {
          error.message = "Sua conta ainda não foi aprovada";
        }
        this.$vs.notification({
          title: 'Erro',
          text: error.message,
          // iconPack: 'feather',
          // icon: 'icon-alert-circle',
          color: 'danger'
        });
        console.error(error);
        this.loadingButton = false;
        this.disableButton = false;
      }
    } else {
      try {
        await authModel.requestLoginCode(this.userInfo.email);
        this.$vs.notification({ color: "success", title: "Sucesso", text: "O código foi enviado para o seu e-mail." });
      } catch (error) {
        if (error.statusCode === 404 || error.message === 'Not Found' || error.message === 'API_NOT_FOUND') {
          error.message = "E-mail não cadastrado."
        }
        this.$vs.notification({
          title: 'Erro',
          text: error.message,
          color: 'danger'
        });
        console.error(error);
      }
    }
  }

  validateFields() {
    const validationDefinition: any = [
      { key: "email", validation: { kind: 'email' } },
      { key: "password", validation: { lengthMin: 8, lengthMax: 100 } },
    ];

    this.fieldErrors = validateEntity(this.userInfo, validationDefinition, ["email", "password"]);
  }

  @Watch('userInfo', { deep: true })
  userInfoChanged() {
    // if a previous error was found, update validation when data changes
    if (Object.keys(this.fieldErrors).length) {
      this.validateFields();
    }
  }
}
